import { type FormValidateInput, schemaResolver } from '@mantine/form';
import type { z } from 'zod';

import type { AllKeysAreStrings } from '@apple/utils/type';

export function typedZod4Resolver<TValues extends AllKeysAreStrings<TValues>>(
	schema: z.ZodType,
): FormValidateInput<TValues> {
	const base = schemaResolver(schema, { sync: true });
	return (values: TValues) => base(values as Record<string, unknown>);
}
